// extracted by mini-css-extract-plugin
export default {"homeAd":"index_homeAd_OpInI","blockA":"index_blockA_lqYSV"};